import axios, { buildApi } from '@/libs/api.request';
let name = '/tracker/traceStatus'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/delete/:id&del']
})